import { VDecryptRequest, VDecryptResponse, VGPS } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class RequestDecryptionEndpoint extends EncryptedEndpoint {
    async getRequestInit({ fileId, hash, latitude, longitude, manufacturerPublicKey }) {
        const requestBytes = VDecryptRequest.encode({
            fileId,
            gps: latitude && longitude
                ? VGPS.fromJSON({
                    latitude,
                    longitude
                })
                : VGPS.fromJSON({}),
            hash,
            includeAuthorizedUsers: true,
            includeDRM: true,
            manufacturerPublicKey
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VDecryptResponse.decode(responseBytes);
    }
}
export const requestDecryptionEndpoint = new RequestDecryptionEndpoint({
    path: '/encryptions/decrypt',
    method: 'POST',
    sideEffect: true,
    body: {},
    schema: VDecryptResponse
});
